export const getTopPrincipalMobileNavigationData = (hasConnectIntegration: boolean) => {
  return [
    {
      value: 0,
      label: 'Connect Hiring Requests',
      route: `/principal/hiring-requests/`,
      isVisible: hasConnectIntegration,
    },
    {
      value: 1,
      label: 'Candidates',
      route: `/principal/candidates/`,
      isVisible: true,
    },
  ];
};
